import i18next from 'i18next';

const languageHelper = () => {
  const isFa = i18next.language === 'fa';
  const isEn = i18next.language === 'en';
  const t = i18next.t;
  return {
    isFa,
    isEn,
    t,
  };
};

export default languageHelper;
